import { takeEvery, put, call, fork, all } from "redux-saga/effects";
// import { v4 as uuidv4 } from 'uuid';

import { Client } from "../../utils/client";
import {
  ONDEMAND_LOAD,
  ondemandLoadSuccess,
  ONDEMAND_FILTER,
  ondemandFilterSuccess,
} from "./actions";
import { setError } from "../../redux-root/actions";

export function* ondemandLoad(action) {
  const { platformType } = action;

  try {
    let favouriteData = {
      channel: [],
      movie: [],
      show: []
    };

    if (localStorage.getItem('_r')) {
      // const favouriteChannelData = yield call(
      //   Client.getData,
      //   "/me/playlists/handles/watchlater/channels"
      // );
      // const favouriteMovieData = yield call(
      //   Client.getData,
      //   "/me/playlists/handles/watchlater/movies"
      // );
      // const favouriteShowData = yield call(
      //   Client.getData,
      //   "/me/playlists/handles/watchlater/shows"
      // );

      // favouriteData.channel = favouriteChannelData.data;
      // favouriteData.movie = favouriteMovieData.data;
      // favouriteData.show = favouriteShowData.data;
    }

    const [vodData, genreData, languageData, allData] = yield all([
      call(Client.getData, `/pages/handles/vod-home-v4?platformType=${encodeURIComponent(platformType)}`),
      call(Client.getData, "/configurations/genres?ispopular=true"),
      call(Client.getData, "/configurations/languages?ispopular=true"),
      call(Client.getData, "/vods?offset=0&limit=200")
    ]);

    const pageData = {
      genre: genreData,
      language: languageData,
      allData: allData.data
    };

    yield put(ondemandLoadSuccess(vodData.data, pageData, favouriteData));
  } catch (error) {
    console.log(error);

    yield put(setError('General Errors', `It's not you. It's us. We are working to fix this...`, error));
  }
}

function* watchOnDemandLoad() {
  yield takeEvery(ONDEMAND_LOAD, ondemandLoad);
}

export function* ondemandSaga() {
  yield fork(watchOnDemandLoad);
  yield fork(watchOnDemandFilter);
}

export function* ondemandFilter(action) {
  const { payload } = action;

  let filterArr = [];
  let urls = [];

  let languageString = "";
  if (payload.filterList.language && payload.filterList.language.length !== 0) {
    let languageArr = [];
    payload.filterList.language.map((lg) =>
      languageArr.push(lg.name)
    );
    languageString = languageArr.join(",");
    languageString = "&language".concat("=", languageString);
  }
  filterArr.push(languageString);

  let genreString = "";
  if (payload.filterList.genre && payload.filterList.genre.length !== 0) {
    let genreArr = [];
    payload.filterList.genre.map((gr) =>
      genreArr.push(gr.name)
    );
    genreString = genreArr.join(",");
    genreString = "&genre".concat("=", encodeURIComponent(genreString));
  }
  filterArr.push(genreString);

  let yearString = "";
  const timeList = payload.filterList.time || [];
  if (timeList.length !== 0) {
    let yearArr = [];
    timeList.map((tm) =>
      yearArr.push(tm.name)
    );
    yearString = yearArr.join(",");
    yearString = "&releaseyear".concat("=", yearString);
  }
  filterArr.push(yearString);

  let channelIdString = "";
  if (payload.filterList.channelOnDemand && payload.filterList.channelOnDemand.length !== 0) {
    let channelIdArr = [];
    payload.filterList.channelOnDemand.map((cod) =>
      channelIdArr.push(cod.cid)
    );
    channelIdString = channelIdArr.join(",");
    channelIdString = "&channelondemandid".concat("=", encodeURIComponent(channelIdString));
  }
  filterArr.push(channelIdString);

  if (payload.bizMode) {
    const includeShows = payload.type === null || payload.type.includes("Shows");
    const includeMovies = payload.type === null || payload.type.includes("Movies");

    if (includeShows) {
      urls.push(`/me/channelondemands/shows?offset=0&limit=200${filterArr.join("")}`);
    }
    if (includeMovies) {
      urls.push(`/me/channelondemands/movies?offset=0&limit=200${filterArr.join("")}`);
    }
  } else {
    if (payload.type === "Shows") {
      urls.push(`/vods?offset=0&limit=200&mediaType=show${filterArr.join("")}`);
    } else if (payload.type === "Movies") {
      urls.push(`/vods/?offset=0&limit=200&mediaType=movie${filterArr.join("")}`);
    } else {
      urls.push(`/vods/?offset=0&limit=200${filterArr.join("")}`);
    }
  }

  try {
    const responses = yield all(urls.map(url => call(Client.getData, url)));

    const mergedData = responses.flatMap(res => res.data || []);

    yield put(ondemandFilterSuccess({
      ...responses[0],
      data: mergedData
    }));
  } catch (error) {
    yield put(ondemandFilterSuccess({ status: 200, data: [] }));

    // yield put(setError("On Demand Title", "On Demand Message description"));
  }
}

function* watchOnDemandFilter() {
  yield takeEvery(ONDEMAND_FILTER, ondemandFilter);
}
